import React from 'react'
import { prepareProductName } from '../../lib/AllGlobalFunction'
import FormikControl from '../../components/FormikControl'
import ReactSelect from '../../components/ReactSelect'
import { updateProductSpecificationMapp } from './productUtils/helperFunctions'

const Specifications = ({
  specificationData,
  values,
  setFieldValue,
  resetForm,
  errors,
  touched
}) => {
  return (
    <div className='card'>
      <div className='card-body'>
        {specificationData?.map((data) => (
          <div key={data?.specId}>
            <h5 className='mb-3 head_h3'>{data?.name}</h5>
            <div className='row mb-3'>
              {data?.types?.map((specTypeData) => (
                <div className='col-md-4' key={specTypeData.specTypeId}>
                  {specTypeData?.fieldType?.toLowerCase() === 'dropdownlist' ? (
                    <div className='input-file-wrapper mb-3'>
                      <label
                        className={`form-label ${
                          specTypeData?.values[0]?.isAllowSpecInFilter &&
                          'required'
                        }`}
                      >
                        {specTypeData?.name}
                      </label>
                      <ReactSelect
                        isRequired
                        id={specTypeData?.name}
                        name={specTypeData?.name}
                        errors={errors[specTypeData?.name]}
                        touched={touched[specTypeData?.name]}
                        isMulti={
                          specTypeData?.values[0]?.isAllowMultipleSelection
                            ? true
                            : false
                        }
                        isClearable={
                          specTypeData?.values[0]?.isAllowSpecInFilter
                            ? false
                            : true
                        }
                        placeholder={specTypeData?.name}
                        value={
                          values.productSpecificationsMapp?.length > 0 &&
                          values?.productSpecificationsMapp
                            ?.filter(
                              (spec) =>
                                spec?.specTypeId === specTypeData?.specTypeId
                            )
                            ?.map((data) => {
                              return {
                                label: data?.value,
                                value: data?.specValueId
                              }
                            })
                        }
                        options={specTypeData?.values?.map(
                          ({ name, specValueId }) => ({
                            value: specValueId,
                            label: name
                          })
                        )}
                        onChange={(e) => {
                          let getSpecification = specificationData?.find(
                            (spec) => spec?.specId === data?.specId
                          )?.types

                          let getSpecTypes = getSpecification?.find(
                            (data) =>
                              data?.specTypeId === specTypeData?.specTypeId
                          )?.values

                          let {
                            isAllowSpecInTitle,
                            titleSequenceOfSpecification
                          } = getSpecTypes[0]

                          let productSpecificationsMapp =
                            values?.productSpecificationsMapp ?? []

                          if (e) {
                            let items = e

                            if (Array.isArray(e)) {
                              let firstElement = e[0]
                              if (e?.length > 1) {
                                setFieldValue(
                                  'productName',
                                  prepareProductName(
                                    firstElement?.label,
                                    1,
                                    specTypeData?.name,
                                    values,
                                    false
                                  )
                                )
                              } else if (e?.length === 1) {
                                if (isAllowSpecInTitle) {
                                  setFieldValue(
                                    'productName',
                                    prepareProductName(
                                      firstElement?.label,
                                      titleSequenceOfSpecification,
                                      specTypeData?.name,
                                      values,
                                      true
                                    )
                                  )
                                }
                              } else {
                                setFieldValue(
                                  'productName',
                                  prepareProductName(
                                    'Spec',
                                    1,
                                    specTypeData?.name,
                                    values,
                                    false
                                  )
                                )
                              }
                            } else {
                              if (isAllowSpecInTitle)
                                setFieldValue(
                                  'productName',
                                  prepareProductName(
                                    e?.label,
                                    titleSequenceOfSpecification,
                                    specTypeData?.name,
                                    values,
                                    true
                                  )
                                )
                              else {
                                setFieldValue(
                                  'productName',
                                  prepareProductName(
                                    e?.label,
                                    1,
                                    specTypeData?.name,
                                    values,
                                    false
                                  )
                                )
                              }
                            }

                            setFieldValue(
                              'productSpecificationsMapp',
                              updateProductSpecificationMapp(
                                productSpecificationsMapp,
                                items,
                                data?.specId,
                                specTypeData?.specTypeId
                              )
                            )
                          } else {
                            let getSpecificationToBeRemoved =
                              productSpecificationsMapp?.find(
                                (spec) =>
                                  spec.specTypeId === specTypeData?.specTypeId
                              )
                            setFieldValue(
                              'productName',
                              prepareProductName(
                                getSpecificationToBeRemoved?.value,
                                1,
                                specTypeData?.name,
                                values,
                                false
                              )
                            )
                            productSpecificationsMapp =
                              productSpecificationsMapp.filter(
                                (spec) =>
                                  spec.specTypeId !== specTypeData?.specTypeId
                              )

                            setFieldValue(
                              'productSpecificationsMapp',
                              productSpecificationsMapp
                            )
                          }
                        }}
                      />
                    </div>
                  ) : (
                    <div className='input-file-wrapper mb-3'>
                      <FormikControl
                        control='input'
                        label={specTypeData?.name}
                        key={specTypeData.specTypeId}
                        type='text'
                        id={specTypeData?.specTypeId}
                        name={specTypeData?.name}
                        value={values?.[specTypeData?.name]}
                        placeholder={specTypeData?.name}
                        onChange={(e) => {
                          let inputValue = e?.target?.value
                          setFieldValue([specTypeData?.name], inputValue)
                          let productSpecificationsMapp =
                            values?.productSpecificationsMapp ?? []
                          setFieldValue(
                            'productSpecificationsMapp',
                            updateProductSpecificationMapp(
                              productSpecificationsMapp,
                              inputValue,
                              data?.specId,
                              specTypeData?.specTypeId
                            )
                          )
                        }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Specifications
